import React, { useCallback, useState } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useMutation } from "@apollo/react-hooks";
import DataGrid from "components/data-grid";
import ValidatedForm from "components/form";
import { mutation, defaultValues, handleSubmit, NewSourceForm } from "./forms/new-form";
import { defaultValidationSchema, scoreboardValidationSchema } from "./forms/new-form/validation-schemas";
import { useCurrentCustomerContext } from "components/current-customer-context";

const SourceNewPage = ({ intl, history }) => {
  const [validationSchema, setValidationSchema] = useState();

  const [createSource] = useMutation(mutation);
  const { currentCustomerId } = useCurrentCustomerContext();

  const handleSelectValidationSchema = useCallback(
    sourceType =>
      setValidationSchema(
        sourceType === "scoreboard" ? scoreboardValidationSchema(intl) : defaultValidationSchema(intl),
      ),
    [intl],
  );

  return (
    <Dashboard>
      <PageHeaderBar title="app.page.source.new" />
      <PageSection>
        <ValidatedForm
          initialValues={defaultValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit({
            createSource,
            history,
            currentCustomerId,
          })}
        >
          {props => (
            <DataGrid>
              <NewSourceForm onSelectValidationSchema={handleSelectValidationSchema} {...props} />
            </DataGrid>
          )}
        </ValidatedForm>
      </PageSection>
    </Dashboard>
  );
};

export default SourceNewPage;
